module.exports = __webpack_public_path__ + "static/media/appointment.652978ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/appointment.svg
// module id = 466
// module chunks = 5